module.exports = __webpack_public_path__ + "static/media/Piedra-Regular.c215fea4.ttf";